// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { formatCoding } from '@medplum/core';
import type { Coding } from '@medplum/fhirtypes';
import type { JSX } from 'react';

export interface CodingDisplayProps {
  readonly value?: Coding;
  readonly includeCode?: boolean;
}

export function CodingDisplay(props: CodingDisplayProps): JSX.Element {
  return <>{formatCoding(props.value, props.includeCode)}</>;
}
